/*
 * ETA Audio — variant auto-correct
 *
 * On products with three options (Style / Color / Size) roughly half the grid has
 * no matching variant. Landing on one of those dead combinations leaves the page
 * with no current variant, so Add-to-cart reads "Unavailable" and the media
 * gallery falls back to rendering EVERY product photo — including colorways from
 * styles the shopper did not pick.
 *
 * Fix: when a selection lands on a combination that has no variant, move the
 * OTHER options to the nearest values that do have one, preferring whatever was
 * already selected. The option the shopper just clicked is always honoured.
 *
 * Corrections are applied one option at a time so the theme can redraw between
 * hops; the pass re-runs itself until the selection is a real variant. Two hops
 * covers the worst case here (e.g. Base/Pirate Gray/3XL -> Retro needs both the
 * colour and the size moved).
 */
(function () {
  'use strict';

  if (!/\/products\//.test(window.location.pathname)) return;

  var SETTLE_MS = 800; /* time allowed for the theme's section re-render */
  var productCache = null;
  var correcting = false;
  var recent = [];

  function loadProduct() {
    if (productCache) return productCache;
    var path = window.location.pathname.split('?')[0].replace(/\/+$/, '');
    productCache = fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache;
  }

  /* Radio groups inside the variant picker, in the order the options appear. */
  function optionGroups() {
    var inputs = [].slice.call(document.querySelectorAll('variant-picker input[type="radio"]'));
    if (!inputs.length) {
      inputs = [].slice.call(document.querySelectorAll('input[type="radio"]')).filter(function (i) {
        return /variant_picker/.test(i.name);
      });
    }
    var order = [];
    var byName = {};
    inputs.forEach(function (input) {
      if (!byName[input.name]) { byName[input.name] = []; order.push(input.name); }
      byName[input.name].push(input);
    });
    return order.map(function (name) { return byName[name]; });
  }

  function selectedValues(groups) {
    return groups.map(function (group) {
      var hit = group.filter(function (i) { return i.checked; })[0];
      return hit ? hit.value : null;
    });
  }

  /* Does any variant match every option index present in `fixed`? */
  function hasMatch(variants, fixed) {
    return variants.some(function (v) {
      for (var i in fixed) {
        if (!Object.prototype.hasOwnProperty.call(fixed, i)) continue;
        if (v.options[i] !== fixed[i]) return false;
      }
      return true;
    });
  }

  /* Stop runaway loops if the variant data and the DOM ever disagree. */
  function guardTripped() {
    var now = Date.now();
    recent = recent.filter(function (t) { return now - t < 5000; });
    if (recent.length >= 6) return true;
    recent.push(now);
    return false;
  }

  /*
   * changedIndex is an option POSITION, not an element: the theme replaces the
   * picker's DOM on every update, so an element reference would go stale between
   * hops.
   */
  function reconcile(changedIndex) {
    loadProduct().then(function (product) {
      if (!product || !product.variants || !product.variants.length) return;

      var groups = optionGroups();
      if (groups.length < 2) return;
      if (changedIndex < 0 || changedIndex >= groups.length) changedIndex = 0;

      var selected = selectedValues(groups);
      if (selected.some(function (v) { return v === null; })) return;

      var full = {};
      selected.forEach(function (v, i) { full[i] = v; });
      if (hasMatch(product.variants, full)) { correcting = false; return; }

      /* Pin the option the shopper just touched, then settle the others. */
      var fixed = {};
      fixed[changedIndex] = selected[changedIndex];

      for (var i = 0; i < groups.length; i++) {
        if (i === changedIndex) continue;

        var candidates = [selected[i]];
        groups[i].forEach(function (input) {
          if (candidates.indexOf(input.value) === -1) candidates.push(input.value);
        });

        var chosen = null;
        for (var c = 0; c < candidates.length; c++) {
          var trial = {};
          for (var k in fixed) {
            if (Object.prototype.hasOwnProperty.call(fixed, k)) trial[k] = fixed[k];
          }
          trial[i] = candidates[c];
          if (hasMatch(product.variants, trial)) { chosen = candidates[c]; break; }
        }
        if (chosen === null) { correcting = false; return; } /* nothing salvageable */
        fixed[i] = chosen;
      }

      /* Apply the first option that needs moving, then come back for the rest. */
      for (var j = 0; j < groups.length; j++) {
        if (j === changedIndex || fixed[j] === selected[j]) continue;

        var target = groups[j].filter(function (input) { return input.value === fixed[j]; })[0];
        if (!target) continue;
        if (guardTripped()) { correcting = false; return; }

        correcting = true;
        var id = window.CSS && CSS.escape ? CSS.escape(target.id) : target.id;
        var label = document.querySelector('label[for="' + id + '"]') || target.closest('label');
        if (label) {
          label.click();
        } else {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }

        setTimeout(function () {
          correcting = false;
          reconcile(changedIndex);
        }, SETTLE_MS);
        return;
      }

      correcting = false;
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;

    /* Ignore the echo of our own synthetic click, but never a real shopper click. */
    if (correcting && !event.isTrusted) return;
    if (event.isTrusted) correcting = false;

    var groups = optionGroups();
    var changedIndex = -1;
    groups.forEach(function (group, i) {
      if (group.indexOf(input) !== -1) changedIndex = i;
    });

    setTimeout(function () { reconcile(changedIndex); }, 60);
  }, true);
})();
